import { API_BASE_URL } from '../../config'
import {
  FETCH_PREFERENCES_REQUEST,
  FETCH_PREFERENCES_SUCCESS,
  FETCH_PREFERENCES_FAILURE,
  UPDATE_PREFERENCES_REQUEST,
  UPDATE_PREFERENCES_FAILURE
} from './preferenceActionTypes'

export const fetchPreferences = () => async (dispatch) => {
  const token = localStorage.getItem('auth_token')
  if (!token) {
    dispatch({ type: FETCH_PREFERENCES_FAILURE, error: 'No authentication token found' })
    return
  }

  dispatch({ type: FETCH_PREFERENCES_REQUEST })

  try {
    const token = localStorage.getItem('auth_token')
    if (!token) {
      dispatch({ type: FETCH_PREFERENCES_FAILURE, error: 'No authentication token found' })
      return
    }

    const [prefsRes, userPrefsRes] = await Promise.all([
      fetch(`${API_BASE_URL}/preferences/`, {
        headers: {
          'accept': 'application/json',
          'Authorization': `Token ${token}`,
        },
        credentials: 'include'
      }),
      fetch(`${API_BASE_URL}/user/profile/preferences/`, {
        headers: {
          'accept': 'application/json',
          'Authorization': `Token ${token}`,
        },
        credentials: 'include'
      })
    ])

    if (!prefsRes.ok || !userPrefsRes.ok) {
      throw new Error('Failed to fetch preferences')
    }

    const [preferences, userPreferences] = await Promise.all([
      prefsRes.json(),
      userPrefsRes.json()
    ])

    dispatch({
      type: FETCH_PREFERENCES_SUCCESS,
      payload: {
        preferences: Array.isArray(preferences) ? preferences : [],
        userPreferences: Array.isArray(userPreferences) ? userPreferences : []
      }
    })
  } catch (error) {
    dispatch({
      type: FETCH_PREFERENCES_FAILURE,
      error: error.message || 'Failed to fetch preferences'
    })
  }
}

export const updatePreferences = (preferenceIds) => async (dispatch) => {
  dispatch({ type: UPDATE_PREFERENCES_REQUEST })

  try {
    const token = localStorage.getItem('auth_token')
    if (!token) {
      throw new Error('No authentication token found')
    }

    const response = await fetch(`${API_BASE_URL}/user/profile/preferences/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`,
        'accept': 'application/json',
        'X-CSRFToken': document.cookie.split('csrftoken=')[1]?.split(';')[0] || ''
      },
      credentials: 'include',
      body: JSON.stringify({
        preference_ids: preferenceIds
      })
    })

    let responseData
    const contentType = response.headers.get('content-type')

    // Only try to parse JSON if the response has content
    if (contentType && contentType.includes('application/json')) {
      responseData = await response.json().catch(() => ({}))
    } else {
      responseData = {}
    }

    if (!response.ok) {
      throw new Error(responseData.detail || 'Failed to update preferences')
    }

    // Always refetch to ensure we have the latest state
    await dispatch(fetchPreferences())

    return responseData || { success: true }
  } catch (error) {
    dispatch({
      type: UPDATE_PREFERENCES_FAILURE,
      error: error.message || 'Failed to update preferences'
    })
    throw error
  }
}
